import { cloneElement, FC, ReactElement } from "react";
import { DomElement } from "htmlparser2";
import ReactHtmlParser from "react-html-parser";

interface EssentialImageProps {
  children?: ReactElement;
  htmlString?: string;
}

/**
 * A wrapper component that automatically injects the data-categories="essential"
 * attribute to child images. This attribute prevents Termly from auto-blocking
 * the image.
 *
 * @example
 * // For React elements: <EssentialImage><img src="..." /></EssentialImage>
 *
 * @example
 * // For HTML strings: <EssentialImage htmlString={htmlContent} />
 */
const EssentialImage: FC<EssentialImageProps> = ({ children, htmlString }) => {
  if (htmlString) {
    return (
      <>
        {ReactHtmlParser(htmlString, {
          transform: (node: DomElement) => {
            if (node.type === "tag" && node.name === "img") {
              node.attribs = {
                ...node.attribs,
                "data-categories": "essential",
              };
            }
          },
        })}
      </>
    );
  }

  if (children) {
    return cloneElement(children, {
      "data-categories": "essential",
    });
  }

  return null;
};

export default EssentialImage;
